(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-mega-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nks-mega-navigation')) {
    customElements.define('nks-mega-navigation', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.menus = Array.from(this.querySelectorAll('.nks-mega-menu'));
        this.menus.forEach(menu => {
          const trigger = menu.querySelector('.nks-mega-menu__trigger');
          const panel = menu.querySelector('.nks-mega-menu__panel');
          menu.addEventListener('pointerenter', event => {
            if (event.pointerType !== 'mouse' || !matchMedia('(min-width: 990px)').matches) return;
            this.openMenu(menu);
          }, options);
          menu.addEventListener('pointerleave', () => {
            this.closeTimer = setTimeout(() => {
              if (!panel.contains(document.activeElement)) this.closeMenus();
            }, 180);
          }, options);
          menu.addEventListener('focusout', event => {
            if (!menu.contains(event.relatedTarget)) this.closeMenus();
          }, options);
          trigger.addEventListener('keydown', event => {
            if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
            event.preventDefault();
            this.openMenu(menu);
            const links = panel.querySelectorAll('a[href]');
            const nextLink = event.key === 'ArrowUp' ? links[links.length - 1] : links[0];
            nextLink?.focus();
          }, options);
        });
        document.addEventListener('pointerdown', event => {
          if (!this.contains(event.target)) this.closeMenus();
        }, options);
        this.addEventListener('keydown', event => {
          if (event.key !== 'Escape') return;
          const openMenu = this.menus.find(menu => !menu.querySelector('.nks-mega-menu__panel').hidden);
          this.closeMenus();
          openMenu?.querySelector('.nks-mega-menu__trigger').focus();
        }, options);
        window.addEventListener('resize', () => this.closeMenus(), options);
        window.addEventListener('scroll', () => this.closeMenus(), { ...options, passive: true });
      }

      openMenu(menu) {
        clearTimeout(this.closeTimer);
        this.closeMenus(menu);
        menu.querySelector('.nks-mega-menu__panel').hidden = false;
        menu.querySelector('.nks-mega-menu__trigger').setAttribute('aria-expanded', 'true');
      }

      closeMenus(except) {
        this.menus.forEach(menu => {
          if (menu === except) return;
          menu.querySelector('.nks-mega-menu__panel').hidden = true;
          menu.querySelector('.nks-mega-menu__trigger').setAttribute('aria-expanded', 'false');
        });
      }

      disconnectedCallback() {
        clearTimeout(this.closeTimer);
        this.controller?.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nks-collection-infinite-scroll"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nks-collection-pagination')) {
    customElements.define('nks-collection-pagination', class extends HTMLElement {
      connectedCallback() {
        this.grid = this.parentElement.querySelector('#product-grid');
        this.button = this.querySelector('[data-collection-load-more]');
        this.label = this.querySelector('[data-collection-load-label]');
        this.status = this.querySelector('[data-collection-load-status]');
        if (!this.grid || this.grid.tagName !== 'UL') return;
        this.nextUrl = this.dataset.nextUrl;
        this.currentPage = Number(this.dataset.currentPage);
        this.loadedUrls = new Set();
        this.seen = new Set(Array.from(this.grid.children, item => item.dataset.productId));
        this.defaultLabel = this.label?.textContent;
        this.dataset.enhanced = 'true';
        this.dataset.state = this.nextUrl ? 'idle' : 'complete';
        if (!this.button || !this.nextUrl) return;
        this.onClick = () => this.loadNextPage();
        this.button.addEventListener('click', this.onClick);
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting) && this.dataset.state === 'idle') {
              this.loadNextPage();
            }
          }, { rootMargin: '900px 0px', threshold: 0 });
          this.observer.observe(this);
        }
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.controller?.abort();
        this.button?.removeEventListener('click', this.onClick);
      }

      async loadNextPage() {
        if (!this.isConnected || !this.nextUrl || this.dataset.state === 'loading') return;
        if (this.closest('.collection')?.classList.contains('loading')) return;
        const url = new URL(this.nextUrl, window.location.href);
        if (url.origin !== window.location.origin || url.pathname !== window.location.pathname) return;
        url.searchParams.set('section_id', this.dataset.sectionId);
        if (this.loadedUrls.has(url.href)) return;
        this.dataset.state = 'loading';
        this.grid.setAttribute('aria-busy', 'true');
        this.button.disabled = true;
        this.label.textContent = this.dataset.labelLoading;
        this.status.textContent = this.dataset.labelLoading;
        this.controller = new AbortController();
        const timeout = window.setTimeout(() => this.controller.abort(), 12000);

        try {
          const response = await fetch(url.href, {
            credentials: 'same-origin',
            headers: { Accept: 'text/html', 'X-Requested-With': 'XMLHttpRequest' },
            signal: this.controller.signal
          });
          if (!response.ok) throw new Error('Collection page unavailable');
          const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
          const nextGrid = parsed.getElementById('product-grid');
          const nextPagination = parsed.querySelector('nks-collection-pagination');
          if (!nextGrid || !nextPagination || nextPagination.dataset.sectionId !== this.dataset.sectionId) {
            throw new Error('Collection grid unavailable');
          }
          const nextPage = Number(nextPagination.dataset.currentPage);
          if (nextPage <= this.currentPage) throw new Error('Collection page did not advance');
          if (!this.isConnected || this.closest('.collection')?.classList.contains('loading')) return;
          const fragment = document.createDocumentFragment();
          let count = 0;
          Array.from(nextGrid.children).forEach(item => {
            const id = item.dataset.productId;
            if (!id || this.seen.has(id)) return;
            this.seen.add(id);
            item.classList.add('scroll-trigger--cancel');
            fragment.appendChild(item);
            count += 1;
          });
          this.grid.appendChild(fragment);
          this.loadedUrls.add(url.href);
          this.currentPage = nextPage;
          this.dataset.currentPage = String(nextPage);
          this.nextUrl = nextPagination.dataset.nextUrl;
          this.dataset.nextUrl = this.nextUrl;
          this.dataset.state = this.nextUrl ? 'idle' : 'complete';
          this.label.textContent = this.defaultLabel;
          this.status.textContent = this.nextUrl
            ? this.dataset.labelLoaded.replace('__COUNT__', String(count))
            : this.dataset.labelComplete;
          if (!this.nextUrl) this.observer?.disconnect();
        } catch (error) {
          if (!this.isConnected) return;
          this.dataset.state = 'retry';
          this.label.textContent = this.dataset.labelRetry;
          this.status.textContent = this.dataset.labelRetry;
        } finally {
          window.clearTimeout(timeout);
          this.grid.setAttribute('aria-busy', 'false');
          this.button.disabled = false;
          if (this.isConnected && this.dataset.state === 'idle') {
            window.requestAnimationFrame(() => {
              const rect = this.getBoundingClientRect();
              if (rect.top < window.innerHeight + 900 && rect.bottom > -900) this.loadNextPage();
            });
          }
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nks-collection-share"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nks-collection-share')) {
    customElements.define('nks-collection-share', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.nativeButton = this.querySelector('[data-native-share]');
        this.details = this.querySelector('details');
        this.summary = this.querySelector('summary');
        this.input = this.querySelector('input');
        this.status = this.querySelector('[role="status"]');
        if (!this.nativeButton || !this.details || !this.summary || !this.input || !this.status) return;
        this.initialized = true;
        const url = new URL(this.input.value, window.location.origin);
        url.search = '';
        url.hash = '';
        this.urlToShare = url.href;
        this.input.value = this.urlToShare;
        this.sharePending = false;
        this.nativeButton.addEventListener('click', () => this.share());
        this.input.addEventListener('click', () => this.input.select());
        this.querySelector('[data-copy-link]').addEventListener('click', () => this.copy());
        this.querySelector('[data-close-share]').addEventListener('click', () => this.close());
        this.addEventListener('keydown', event => {
          if (event.key === 'Escape' && this.details.open) {
            event.preventDefault();
            this.close();
          }
        });
        if (typeof navigator.share === 'function') {
          this.details.hidden = true;
          this.nativeButton.hidden = false;
        }
      }

      async share() {
        if (this.sharePending) return;
        this.sharePending = true;
        try {
          await navigator.share({ url: this.urlToShare, title: this.dataset.shareTitle });
        } catch (error) {
          if (error?.name !== 'AbortError') {
            this.nativeButton.hidden = true;
            this.details.hidden = false;
            this.details.open = true;
            this.input.focus();
            this.input.select();
          }
        } finally {
          this.sharePending = false;
        }
      }

      async copy() {
        try {
          await navigator.clipboard.writeText(this.urlToShare);
          this.status.textContent = this.dataset.copySuccess;
          this.status.hidden = false;
        } catch (error) {
          this.status.textContent = this.dataset.copyFailed;
          this.status.hidden = false;
          this.input.focus();
          this.input.select();
        }
      }

      close() {
        this.details.open = false;
        this.status.hidden = true;
        this.status.textContent = '';
        this.summary.focus();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nks-commerce-polish"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.nksNativeCartAdditionReady) return;
    window.nksNativeCartAdditionReady = true;
    let feedbackTimer;

    const addButtonEffects = new WeakMap();
    const pulseAddButton = (button) => {
      try {
        if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true' || button.dataset.nksIconAction === 'order') return;
        if (!button.matches('[data-nks-icon-action="add"], [data-nks-ajax-add], [name="add"]')) return;
        const previous = addButtonEffects.get(button);
        previous?.animation?.cancel();
        window.clearTimeout(previous?.timer);
        button.classList.add('nks-add-feedback');
        const effect = {};
        addButtonEffects.set(button, effect);
        effect.timer = window.setTimeout(() => {
          if (addButtonEffects.get(button) !== effect) return;
          button.classList.remove('nks-add-feedback');
          addButtonEffects.delete(button);
        }, 720);
        if (typeof button.animate === 'function' && !window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) {
          effect.animation = button.animate([
            { scale: '1', offset: 0 },
            { scale: '0.92', offset: 0.18 },
            { scale: '1.08', offset: 0.48 },
            { scale: '1', offset: 1 },
          ], { duration: 520, easing: 'cubic-bezier(.22,.7,.25,1)' });
        }
      } catch (error) {}
    };

    let cartPulseUntil = 0;
    let cartPulseTimer;
    let cartGradientSequence = 0;
    const cartAnimations = new WeakMap();
    const cartPulseTargets = () => [
      document.getElementById('cart-icon-bubble'),
      document.querySelector('.nks-mobile-dock__count')?.closest?.('.nks-mobile-dock__item'),
    ].filter(Boolean);

    const maintainCartPulse = (animate = false) => {
      try {
        const active = Date.now() < cartPulseUntil;
        cartPulseTargets().forEach((target) => {
          target.classList.toggle('nks-cart-refresh', active);
          const svg = target.querySelector('svg');
          if (!svg || !active) return;
          if (!svg.dataset.nksCartGradient) {
            const namespace = 'http://www.w3.org/2000/svg';
            const defs = document.createElementNS(namespace, 'defs');
            const gradient = document.createElementNS(namespace, 'linearGradient');
            const id = 'nks-cart-refresh-' + ++cartGradientSequence;
            gradient.setAttribute('id', id);
            gradient.setAttribute('gradientUnits', 'userSpaceOnUse');
            gradient.setAttribute('x1', '0');
            gradient.setAttribute('y1', '24');
            gradient.setAttribute('x2', '24');
            gradient.setAttribute('y2', '0');
            ['#1769e8', '#089799', '#ef8026', '#d74898', '#7545dc', '#1769e8'].forEach((color, index) => {
              const stop = document.createElementNS(namespace, 'stop');
              stop.setAttribute('offset', index * 20 + '%');
              stop.setAttribute('stop-color', color);
              gradient.append(stop);
            });
            defs.append(gradient);
            svg.append(defs);
            svg.dataset.nksCartGradient = id;
            svg.style.setProperty('--nks-cart-refresh-paint', 'url("#' + id + '")');
            svg.querySelectorAll('path, circle, rect, polyline, polygon').forEach((shape) => {
              const stroke = shape.getAttribute('stroke') || svg.getAttribute('stroke');
              shape.dataset.nksCartPaint = stroke && stroke !== 'none' ? 'stroke' : 'fill';
            });
          }
          if (animate && typeof svg.animate === 'function') {
            cartAnimations.get(svg)?.cancel();
            if (!window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) {
              cartAnimations.set(svg, svg.animate([
                { transform: 'rotate(0deg) scale(1)' },
                { transform: 'rotate(180deg) scale(1.12)' },
                { transform: 'rotate(360deg) scale(1)' },
              ], { duration: 650, easing: 'cubic-bezier(.22,.7,.25,1)' }));
            }
          }
        });
      } catch (error) {}
    };

    const pulseCart = () => {
      cartPulseUntil = Date.now() + 1100;
      window.clearTimeout(cartPulseTimer);
      maintainCartPulse(true);
      cartPulseTimer = window.setTimeout(() => {
        cartPulseUntil = 0;
        maintainCartPulse();
      }, 1100);
    };

    const showFeedback = (message, state) => {
      const feedback = document.querySelector('.nks-commerce-feedback');
      if (!feedback) return;
      window.clearTimeout(feedbackTimer);
      feedback.textContent = message;
      feedback.dataset.state = state;
      feedback.classList.add('is-visible');
      if (state !== 'loading') feedbackTimer = window.setTimeout(() => feedback.classList.remove('is-visible'), state === 'error' ? 6500 : 3200);
    };

    const updateRenderedCart = (sections) => {
      const rendered = [];
      if (!sections) return rendered;
      if (sections['cart-icon-bubble']) {
        const html = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
        const source = html.querySelector('.shopify-section');
        const target = document.getElementById('cart-icon-bubble');
        if (source && target) {
          target.innerHTML = source.innerHTML;
          rendered.push('cart-icon-bubble');
        }
      }
      if (sections['cart-drawer']) {
        const html = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        const source = html.querySelector('.drawer__inner');
        const target = document.querySelector('cart-drawer .drawer__inner');
        if (source && target) {
          target.replaceWith(source);
          document.querySelector('cart-drawer')?.classList.remove('is-empty');
          rendered.push('cart-drawer');
        }
      }
      return rendered;
    };

    let cartRevision = 0;
    let pendingAdditions = 0;
    let refreshing = false;
    const refreshQueue = [];
    const feedback = document.querySelector('.nks-commerce-feedback');
    let confirmedCount = Number(feedback?.dataset.cartCount) || 0;
    let mutationQueue = Promise.resolve();
    let countRead;
    let countReadRevision;
    let operationSequence = 0;
    let failureRevision = 0;
    let batchError = '';
    const optimisticQuantities = new Map();
    const idleWaiters = [];
    const handoffKey = 'nks-continue-cart-v1';
    let handoffLoading = false;
    let handoffFailure = false;
    let handoffCompletion;

    const applyCartDocument = (html) => {
      const cartItems = document.querySelector('cart-items');
      const newItems = html.querySelector('cart-items');
      const footer = document.getElementById('main-cart-footer');
      const newFooter = html.getElementById('main-cart-footer');
      if (!cartItems || !newItems || !footer || !newFooter) return false;
      cartItems.className = newItems.className;
      cartItems.innerHTML = newItems.innerHTML;
      footer.className = newFooter.className;
      footer.innerHTML = newFooter.innerHTML;
      cartItems.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');
      return true;
    };

    const resumeContinueOrder = async () => {
      const root = window.Shopify?.routes?.root || '/';
      if (window.location.pathname.replace(/\/$/, '') !== root + 'cart') return false;
      let entry;
      try {
        entry = JSON.parse(window.sessionStorage.getItem(handoffKey) || 'null');
        if (!entry) return false;
        if (entry.phase !== 'queued' || !Array.isArray(entry.fields) || Date.now() - entry.createdAt > 300000 || entry.createdAt > Date.now()) {
          window.sessionStorage.removeItem(handoffKey);
          if (entry.phase === 'sending') showFeedback(feedback?.dataset.errorMessage, 'error');
          return false;
        }
        const destination = new URL(entry.destination, window.location.href);
        if (destination.origin !== window.location.origin || destination.pathname !== root + 'cart') throw new Error('Invalid cart destination');
        entry.phase = 'sending';
        window.sessionStorage.setItem(handoffKey, JSON.stringify(entry));
      } catch (error) {
        showFeedback(feedback?.dataset.errorMessage, 'error');
        return false;
      }
      const formData = new FormData();
      for (const field of entry.fields) {
        if (!Array.isArray(field) || field.length !== 2 || field.some(value => typeof value !== 'string')) return false;
        formData.append(field[0], field[1]);
      }
      const cartItems = document.querySelector('cart-items');
      const footer = document.getElementById('main-cart-footer');
      const itemsSection = document.getElementById('main-cart-items')?.dataset.id;
      const footerSection = footer?.dataset.id;
      const cartSections = itemsSection && footerSection ? [itemsSection, footerSection, 'cart-icon-bubble'] : undefined;
      if (cartSections && document.querySelector('cart-drawer')) cartSections.push('cart-drawer');
      const panel = document.createElement('div');
      panel.className = 'nks-cart-handoff';
      panel.setAttribute('role', 'status');
      panel.setAttribute('aria-live', 'polite');
      panel.textContent = feedback?.dataset.loadingMessage || '';
      document.getElementById('MainContent')?.prepend(panel);
      const wasItemsInert = cartItems?.inert;
      const wasFooterInert = footer?.inert;
      if (cartItems) cartItems.inert = true;
      if (footer) footer.inert = true;
      handoffLoading = true;
      handoffFailure = false;
      let rendered = false;
      let success = false;
      try {
        success = await window.nksFastCart.add(formData, {
          source: 'nks-icon-purchase',
          cartSections,
          onSuccess: (data) => {
            try { window.sessionStorage.removeItem(handoffKey); } catch (error) {}
            if (itemsSection && footerSection && typeof data.sections?.[itemsSection] === 'string' && typeof data.sections?.[footerSection] === 'string') {
              const html = new DOMParser().parseFromString(data.sections[itemsSection] + data.sections[footerSection], 'text/html');
              rendered = applyCartDocument(html);
              if (rendered) return ['main-cart-items', 'main-cart-footer', ...updateRenderedCart(data.sections)];
            }
            return [];
          },
        });
        if (!rendered) {
          const response = await fetch(root + 'cart', { headers: { Accept: 'text/html' }, cache: 'no-store' });
          if (!response.ok) throw new Error('Cart rendering failed');
          rendered = applyCartDocument(new DOMParser().parseFromString(await response.text(), 'text/html'));
          if (!rendered) throw new Error('Cart sections missing');
        }
        if (success) panel.remove();
        else {
          handoffFailure = true;
          panel.textContent = batchError || feedback?.dataset.errorMessage || '';
        }
        return success;
      } catch (error) {
        handoffFailure = true;
        panel.textContent = feedback?.dataset.errorMessage || '';
        return false;
      } finally {
        try { window.sessionStorage.removeItem(handoffKey); } catch (error) {}
        if (cartItems) cartItems.inert = Boolean(wasItemsInert);
        if (footer) footer.inert = Boolean(wasFooterInert);
        handoffLoading = false;
      }
    };

    const renderCount = () => {
      const count = confirmedCount + Array.from(optimisticQuantities.values()).reduce((total, quantity) => total + quantity, 0);
      const label = count === 1 ? feedback?.dataset.countLabelOne : feedback?.dataset.countLabelMany?.replace('999999', String(count));
      const icon = document.getElementById('cart-icon-bubble');
      if (icon) {
        let bubble = icon.querySelector('.cart-count-bubble');
        if (!bubble && count > 0) {
          bubble = document.createElement('div');
          bubble.className = 'cart-count-bubble';
          const number = document.createElement('span');
          number.setAttribute('aria-hidden', 'true');
          const description = document.createElement('span');
          description.className = 'visually-hidden';
          bubble.append(number, description);
          icon.append(bubble);
        }
        if (bubble) {
          if (count === 0) bubble.remove();
          const number = bubble.querySelector('[aria-hidden="true"]');
          const description = bubble.querySelector('.visually-hidden');
          if (number) number.textContent = count > 99 ? '99+' : String(count);
          if (description && label) description.textContent = label;
        }
        icon.dataset.nksCartPending = String(pendingAdditions);
      }
      document.querySelectorAll('.nks-mobile-dock__count').forEach((badge) => {
        badge.textContent = String(count);
        badge.classList.toggle('is-empty', count === 0);
        badge.dataset.nksCartPending = String(pendingAdditions);
        if (label) badge.setAttribute('aria-label', label);
      });
      maintainCartPulse();
    };

    const syncCount = () => {
      if (pendingAdditions) return Promise.resolve(false);
      const revision = cartRevision;
      if (countRead) return countReadRevision === revision ? countRead : countRead.then(syncCount);
      countReadRevision = revision;
      const root = window.Shopify?.routes?.root || '/';
      countRead = (async () => {
        try {
          const response = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
          if (!response.ok) return false;
          const cart = await response.json();
          if (revision !== cartRevision || pendingAdditions || !Number.isInteger(cart.item_count)) return false;
          confirmedCount = cart.item_count;
          renderCount();
          return true;
        } catch (error) {
          return false;
        } finally {
          countRead = undefined;
        }
      })();
      return countRead;
    };

    const notifyCart = (detail, renderedSections) => {
      try {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          Promise.resolve(publish(PUB_SUB_EVENTS.cartUpdate, { ...detail, renderedSections })).catch(() => {});
        }
      } catch (error) {}
    };

    const refreshCart = async () => {
      if (refreshing || pendingAdditions || !refreshQueue.length) return;
      refreshing = true;
      try {
        while (refreshQueue.length && !pendingAdditions) {
          const revision = cartRevision;
          const details = refreshQueue.splice(0);
          const requested = new Set(['cart-icon-bubble']);
          if (document.querySelector('cart-drawer')) requested.add('cart-drawer');
          details.forEach(({ cartUI }) => cartUI?.getSectionsToRender().forEach(({ id }) => requested.add(id)));
          const root = window.Shopify?.routes?.root || '/';
          try {
            const response = await fetch(root + '?sections=' + encodeURIComponent(Array.from(requested).join(',')));
            if (!response.ok) throw new Error('Cart refresh failed');
            const sections = await response.json();
            if (!sections || !Array.from(requested).every(id => Object.hasOwn(sections, id))) throw new Error('Cart sections missing');
            if (revision !== cartRevision || pendingAdditions) {
              refreshQueue.unshift(...details);
              continue;
            }
            const renderedSections = updateRenderedCart(sections);
            const renderedUIs = new Set();
            details.forEach((detail) => {
              const cartUI = detail.cartUI;
              if (cartUI && !renderedUIs.has(cartUI) && cartUI.getSectionsToRender().every(({ id }) => typeof sections[id] === 'string')) {
                try {
                  cartUI.renderContents({ ...detail.cartData, sections });
                  renderedUIs.add(cartUI);
                  cartUI.getSectionsToRender().forEach(({ id }) => {
                    if (!renderedSections.includes(id)) renderedSections.push(id);
                  });
                } catch (error) {}
              }
            });
            details.forEach(({ cartUI, ...detail }) => notifyCart(detail, renderedSections));
          } catch (error) {
            if (revision !== cartRevision || pendingAdditions) {
              refreshQueue.unshift(...details);
              continue;
            }
            details.forEach(({ cartUI, ...detail }) => notifyCart(detail, []));
          }
        }
      } finally {
        maintainCartPulse();
        refreshing = false;
        if (!pendingAdditions && refreshQueue.length) void refreshCart();
      }
    };

    window.nksFastCart = {
      showFeedback,
      syncCount,
      continueToCart(formData, cartUrl) {
        if (pendingAdditions || handoffLoading) return false;
        const quantity = Number(formData.get('quantity') || 1);
        if (!formData.get('id') || !Number.isInteger(quantity) || quantity < 1) return false;
        const root = window.Shopify?.routes?.root || '/';
        const destination = new URL(cartUrl || root + 'cart', window.location.href);
        if (destination.origin !== window.location.origin || destination.pathname !== root + 'cart') return false;
        const fields = [];
        for (const [name, value] of formData.entries()) {
          if (['return_to', 'sections', 'sections_url'].includes(name)) continue;
          if (typeof value !== 'string') {
            if (value.size === 0 && !value.name) continue;
            return false;
          }
          fields.push([name, value]);
        }
        try {
          const previous = JSON.parse(window.sessionStorage.getItem(handoffKey) || 'null');
          if (previous?.phase === 'sending') return false;
          const serialized = JSON.stringify({ phase: 'queued', createdAt: Date.now(), destination: destination.href, fields });
          window.sessionStorage.setItem(handoffKey, serialized);
          if (window.sessionStorage.getItem(handoffKey) !== serialized) {
            window.sessionStorage.removeItem(handoffKey);
            return false;
          }
          if (window.location.pathname.replace(/\/$/, '') === destination.pathname) {
            window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
            handoffCompletion = resumeContinueOrder();
            return handoffCompletion;
          }
          window.location.assign(destination.href);
          return true;
        } catch (error) {
          try { window.sessionStorage.removeItem(handoffKey); } catch (storageError) {}
          return false;
        }
      },
      async whenIdle() {
        if (handoffCompletion) await handoffCompletion;
        const failures = failureRevision;
        while (true) {
          const queue = mutationQueue;
          await queue;
          if (pendingAdditions) await new Promise((resolve) => idleWaiters.push(resolve));
          await syncCount();
          if (queue === mutationQueue && !pendingAdditions) return !handoffFailure && !batchError && failures === failureRevision;
        }
      },
      add(formData, { button, source, cartUI, onSuccess, onError, cartSections } = {}) {
        const quantity = Number(formData.get('quantity') || 1);
        if (!formData.get('id') || !Number.isInteger(quantity) || quantity < 1) return Promise.resolve(false);
        formData.delete('return_to');
        formData.delete('sections');
        formData.delete('sections_url');
        if (cartSections?.length) {
          formData.set('sections', cartSections.join(','));
          formData.set('sections_url', window.location.pathname);
        }
        if (!pendingAdditions) batchError = '';
        const operation = ++operationSequence;
        optimisticQuantities.set(operation, quantity);
        const finish = this.begin();
        renderCount();
        pulseAddButton(button);
        if (button) button.dataset.nksPendingAdds = String(Number(button.dataset.nksPendingAdds || 0) + 1);
        showFeedback(feedback?.dataset.loadingMessage, 'loading');

        const task = mutationQueue.then(async () => {
          let data;
          try {
            const root = window.Shopify?.routes?.root || '/';
            const response = await fetch(root + 'cart/add.js', {
              method: 'POST',
              headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              body: formData,
            });
            data = await response.json();
            if (!response.ok || data.status) throw new Error(data.description || feedback?.dataset.errorMessage);
            confirmedCount += quantity;
            optimisticQuantities.delete(operation);
            renderCount();
            let renderedSections;
            try { renderedSections = onSuccess?.(data); } catch (error) {}
            finish({ source, productVariantId: formData.get('id'), cartData: data, cartUI, ...(Array.isArray(renderedSections) && renderedSections.length ? { renderedSections } : {}) });
            return true;
          } catch (error) {
            optimisticQuantities.delete(operation);
            failureRevision += 1;
            batchError = error.message || feedback?.dataset.errorMessage;
            renderCount();
            showFeedback(batchError, 'error');
            try { onError?.(error, data); } catch (callbackError) {}
            finish({ source: source || 'nks-native-cart-addition', productVariantId: formData.get('id') });
            return false;
          } finally {
            if (button) button.dataset.nksPendingAdds = String(Math.max(0, Number(button.dataset.nksPendingAdds || 0) - 1));
            finish();
          }
        });
        mutationQueue = task.then(() => {});
        return task;
      },
      begin() {
        pendingAdditions += 1;
        cartRevision += 1;
        pulseCart();
        let finished = false;
        return (detail) => {
          if (finished) return;
          finished = true;
          pendingAdditions -= 1;
          cartRevision += 1;
          if (detail?.renderedSections) notifyCart(detail, detail.renderedSections);
          else if (detail) refreshQueue.push(detail);
          renderCount();
          if (!pendingAdditions) {
            idleWaiters.splice(0).forEach((resolve) => resolve());
            showFeedback(batchError || feedback?.dataset.successMessage, batchError ? 'error' : 'success');
            void syncCount();
          }
          void refreshCart();
        };
      },
    };

    handoffCompletion = resumeContinueOrder();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (['nks-icon-purchase', 'nks-native-cart-addition', 'product-form'].includes(event.source)) return;
        cartRevision += 1;
        if (!pendingAdditions && Number.isInteger(event.cartData?.item_count)) {
          confirmedCount = event.cartData.item_count;
          renderCount();
        } else {
          void syncCount();
        }
      });
    }

    let navigationSequence = 0;
    window.addEventListener('beforeunload', (event) => {
      if (!pendingAdditions && !handoffLoading) return;
      event.preventDefault();
      event.returnValue = '';
    });
    document.addEventListener('click', (event) => {
      if ((!pendingAdditions && !handoffLoading) || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const link = event.target.closest?.('a[href]');
      if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self') || link.getAttribute('aria-haspopup')) return;
      const url = new URL(link.href, window.location.href);
      if (url.origin !== window.location.origin || (url.pathname === window.location.pathname && url.search === window.location.search && url.hash)) return;
      event.preventDefault();
      const navigation = ++navigationSequence;
      void window.nksFastCart.whenIdle().then((success) => {
        if (success && navigation === navigationSequence) window.location.assign(url.href);
      });
    });

    document.addEventListener('submit', (event) => {
      const form = event.target;
      const button = event.submitter;
      if ((pendingAdditions || handoffLoading) && button?.name === 'checkout' && form instanceof HTMLFormElement) {
        event.preventDefault();
        void window.nksFastCart.whenIdle().then((success) => {
          if (success && button.isConnected && form.isConnected) form.requestSubmit(button);
        });
        return;
      }
      if (!(form instanceof HTMLFormElement) || !button?.matches('[data-nks-ajax-add]')) return;
      event.preventDefault();
      if (button.disabled) return;
      const formData = new FormData(form);
      if (!formData.get('id')) return;
      void window.nksFastCart.add(formData, { button, source: 'nks-native-cart-addition' });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nks-product-note"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nks-cart-line-note')) {
    customElements.define(
      'nks-cart-line-note',
      class NksCartLineNote extends HTMLElement {
        connectedCallback() {
          if (this.dataset.bound === 'true') return;

          this.dataset.bound = 'true';
          this.input = this.querySelector('textarea');
          this.status = this.querySelector('[role="status"]');
          this.properties = {};
          this.savedValue = this.input.value;
          this.saveTimer = null;
          this.saving = false;
          this.needsSave = false;

          this.querySelectorAll('[data-property-name][data-property-value]').forEach((property) => {
            this.properties[property.dataset.propertyName] = property.dataset.propertyValue;
          });

          this.input.addEventListener('input', () => {
            window.clearTimeout(this.saveTimer);

            if (this.input.value === this.savedValue) {
              this.setStatus('');
              return;
            }

            this.setStatus('saving');
            this.saveTimer = window.setTimeout(() => this.save(), 650);
          });

          this.input.addEventListener('blur', () => {
            window.clearTimeout(this.saveTimer);
            this.save();
          });
        }

        disconnectedCallback() {
          window.clearTimeout(this.saveTimer);
        }

        setStatus(state) {
          const messages = {
            saving: this.dataset.savingMessage,
            saved: this.dataset.savedMessage,
            error: this.dataset.errorMessage,
          };

          this.status.dataset.state = state;
          this.status.textContent = messages[state] || '';
        }

        propertiesMatch(firstProperties, secondProperties) {
          const first = firstProperties || {};
          const second = secondProperties || {};
          const firstKeys = Object.keys(first).sort();
          const secondKeys = Object.keys(second).sort();

          return (
            firstKeys.length === secondKeys.length &&
            firstKeys.every((key, index) => key === secondKeys[index] && String(first[key]) === String(second[key]))
          );
        }

        async save() {
          window.clearTimeout(this.saveTimer);

          if (this.saving) {
            this.needsSave = true;
            return;
          }

          const inputValue = this.input.value;
          const valueToSave = inputValue.trim();
          if (valueToSave === this.savedValue) {
            this.setStatus(valueToSave ? 'saved' : '');
            return;
          }

          const nextProperties = { ...this.properties };
          if (valueToSave) {
            nextProperties[this.dataset.propertyName] = valueToSave;
          } else {
            delete nextProperties[this.dataset.propertyName];
          }

          this.saving = true;
          this.needsSave = false;
          this.setStatus('saving');

          try {
            const root = window.Shopify?.routes?.root || '/';
            const response = await fetch(`${root}cart/change.js`, {
              method: 'POST',
              credentials: 'same-origin',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                id: this.dataset.lineKey,
                quantity: Number(this.dataset.quantity),
                properties: nextProperties,
              }),
            });

            if (!response.ok) throw new Error('Cart line update failed');

            const cart = await response.json();
            const variantId = Number(this.dataset.variantId);
            const updatedItem = cart.items.find(
              (cartItem) => cartItem.variant_id === variantId && this.propertiesMatch(cartItem.properties, nextProperties)
            );

            if (!updatedItem) throw new Error('Updated cart line was not returned');

            this.properties = { ...(updatedItem.properties || {}) };
            this.savedValue = valueToSave;
            this.dataset.lineKey = updatedItem.key;
            this.dataset.quantity = String(updatedItem.quantity);
            this.dataset.lineIndex = String(cart.items.indexOf(updatedItem) + 1);

            if (this.input.value === inputValue) {
              this.input.value = valueToSave;
              this.setStatus(valueToSave ? 'saved' : '');
            } else {
              this.needsSave = true;
            }

            const cartItems = this.closest('cart-items, cart-drawer-items');
            if (cartItems && cartItems.querySelectorAll('.cart-item').length !== cart.items.length) {
              await cartItems.onCartUpdate?.();
            }
          } catch (error) {
            this.setStatus('error');
          } finally {
            this.saving = false;
            if (this.needsSave && this.isConnected) {
              this.saveTimer = window.setTimeout(() => this.save(), 150);
            }
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nks-purchase-icon"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('nks-icon-purchase')) return;
    let feedbackTimer;

    const showFeedback = (purchase, message, state) => {
      const feedback = document.querySelector('.nks-commerce-feedback');
      if (!feedback || !message) return;
      clearTimeout(feedbackTimer);
      feedback.textContent = message;
      feedback.dataset.state = state;
      feedback.classList.add('is-visible');
      if (state !== 'loading') feedbackTimer = setTimeout(() => feedback.classList.remove('is-visible'), state === 'error' ? 6500 : 3200);
    };

    const updateRenderedCart = (sections) => {
      const rendered = [];
      if (!sections) return rendered;
      if (sections['cart-icon-bubble']) {
        const html = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
        const source = html.querySelector('.shopify-section');
        const target = document.getElementById('cart-icon-bubble');
        if (source && target) {
          target.innerHTML = source.innerHTML;
          rendered.push('cart-icon-bubble');
        }
      }
      if (sections['cart-drawer']) {
        const html = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        const source = html.querySelector('.drawer__inner');
        const target = document.querySelector('cart-drawer .drawer__inner');
        if (source && target) {
          target.replaceWith(source);
          document.querySelector('cart-drawer')?.classList.remove('is-empty');
          rendered.push('cart-drawer');
        }
      }
      return rendered;
    };

    window.addEventListener('pageshow', (event) => {
      if (!event.persisted) return;
      document.querySelectorAll('nks-icon-purchase').forEach((purchase) => { purchase.busy = false; });
    });

    customElements.define('nks-icon-purchase', class extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        const form = this.querySelector('form');
        if (!form) return;
        this.bound = true;
        form.addEventListener('submit', (event) => this.addProduct(event, form));
      }

      async addProduct(event, form) {
        event.preventDefault();
        event.stopPropagation();
        const button = event.submitter || form.querySelector('[data-nks-icon-action="add"]');
        if (this.busy || !button?.matches('[data-nks-icon-action]') || button.disabled) return;
        const formData = new FormData(form);
        if (!formData.get('id')) return;
        const fastCart = window.nksFastCart;
        if (fastCart?.add) {
          const advance = button.dataset.nksIconAction === 'order';
          if (advance && fastCart.continueToCart) {
            const handoff = fastCart.continueToCart(formData, this.dataset.cartUrl);
            if (handoff) {
              this.busy = true;
              if (handoff === true) return;
              try { await handoff; } finally { this.busy = false; }
              return;
            }
          }
          const controls = advance ? Array.from(form.querySelectorAll('button[type="submit"], select'), (control) => ({ control, disabled: control.disabled })) : [];
          if (advance) {
            this.busy = true;
            controls.forEach(({ control }) => { control.disabled = true; });
            button.setAttribute('aria-busy', 'true');
          }
          let navigationStarted = false;
          try {
            const success = await fastCart.add(formData, {
              button,
              source: 'nks-icon-purchase',
              onSuccess: () => this.dispatchEvent(new CustomEvent('nks:cart-added', { bubbles: true, detail: { variantId: formData.get('id'), advance } })),
            });
            if (advance && success && await fastCart.whenIdle()) {
              const root = window.Shopify?.routes?.root || '/';
              window.location.assign(this.dataset.cartUrl || root + 'cart');
              navigationStarted = true;
            }
          } finally {
            if (advance && !navigationStarted) {
              controls.forEach(({ control, disabled }) => { control.disabled = disabled; });
              button.removeAttribute('aria-busy');
              this.busy = false;
            }
          }
          return;
        }
        const finishCartOperation = fastCart?.begin();
        this.busy = true;
        const advance = button.dataset.nksIconAction === 'order';
        const controls = Array.from(form.querySelectorAll('button[type="submit"], select'), (control) => ({ control, disabled: control.disabled }));
        controls.forEach(({ control }) => { control.disabled = true; });
        button.setAttribute('aria-busy', 'true');
        const loadingLabel = button.querySelector('[data-nks-loading-label]')?.dataset.nksLoadingLabel;
        showFeedback(this, loadingLabel, 'loading');
        formData.delete('return_to');
        if (advance || fastCart) {
          formData.delete('sections');
          formData.delete('sections_url');
        } else {
          formData.set('sections', 'cart-icon-bubble,cart-drawer');
          formData.set('sections_url', window.location.pathname);
        }
        const root = window.Shopify?.routes?.root || '/';
        let additionConfirmed = false;
        let navigationStarted = false;

        try {
          const response = await fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: formData,
          });
          const data = await response.json();
          if (!response.ok || data.status) throw new Error(data.description || this.dataset.errorMessage);
          additionConfirmed = true;
          showFeedback(this, this.dataset.successMessage, 'success');
          if (advance) {
            finishCartOperation?.();
            try {
              this.dispatchEvent(new CustomEvent('nks:cart-added', { bubbles: true, detail: { variantId: formData.get('id'), advance } }));
            } catch (eventError) {}
            window.location.assign(this.dataset.cartUrl || root + 'cart');
            navigationStarted = true;
            return;
          }
          if (fastCart) {
            finishCartOperation({ source: 'nks-icon-purchase', productVariantId: formData.get('id'), cartData: data });
            try {
              this.dispatchEvent(new CustomEvent('nks:cart-added', { bubbles: true, detail: { variantId: formData.get('id'), advance } }));
            } catch (eventError) {}
            return;
          }
          let renderedSections = [];
          try {
            renderedSections = updateRenderedCart(data.sections);
          } catch (renderError) {}
          try {
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              Promise.resolve(publish(PUB_SUB_EVENTS.cartUpdate, { source: 'nks-icon-purchase', productVariantId: formData.get('id'), cartData: data, renderedSections })).catch(() => {});
            }
          } catch (publishError) {}
          try {
            this.dispatchEvent(new CustomEvent('nks:cart-added', { bubbles: true, detail: { variantId: formData.get('id'), advance } }));
          } catch (eventError) {}
        } catch (error) {
          if (!additionConfirmed) showFeedback(this, error.message || this.dataset.errorMessage, 'error');
        } finally {
          finishCartOperation?.();
          if (!navigationStarted) {
            controls.forEach(({ control, disabled }) => { control.disabled = disabled; });
            button.removeAttribute('aria-busy');
            this.busy = false;
          }
        }
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
